(function (root, factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory;
    }

    root.SkmPublicContentEditor = factory;
}(typeof globalThis !== 'undefined' ? globalThis : this, function createPublicContentEditor(options) {
    'use strict';

    options = options || {};
    var documentRef = options.document;
    var fetchRef = options.fetch;
    var windowRef = options.window || (documentRef && documentRef.defaultView);
    var rootElement = null;
    var payload = null;
    var selectedFieldKey = '';
    var selectedFaqContextKey = '';
    var selectedFaqItemId = '';
    var busy = false;

    function parsePayload() {
        var payloadElement = documentRef.getElementById('publicContentEditorPayload');
        if (!payloadElement) return null;

        try {
            return JSON.parse(payloadElement.textContent || '{}');
        } catch (error) {
            return null;
        }
    }

    function field(key) {
        return (payload.fields || []).find(function (item) { return item.key === key; }) || null;
    }

    function currentValue(key) {
        if (payload.values && Object.prototype.hasOwnProperty.call(payload.values, key)) {
            return String(payload.values[key] == null ? '' : payload.values[key]);
        }
        var definition = field(key);
        return definition ? String(definition.default || '') : '';
    }

    function setMessage(message, kind, inline) {
        var target = rootElement.querySelector('[data-public-content-message]');
        if (!target) return;
        target.setAttribute('data-skm-notice', !message || kind === 'progress' || inline ? 'inline' : '');
        target.textContent = message || '';
        target.dataset.kind = kind || '';
    }

    function showSavedToast(text) {
        if (!windowRef || !windowRef.skm || typeof windowRef.skm.toast !== 'function') return;
        windowRef.skm.toast('success', '저장되었습니다', text ? { text: text } : undefined);
    }

    function setStatus(snapshot) {
        var nextRevision = snapshot.revision;
        if (nextRevision === null || typeof nextRevision === 'undefined') {
            nextRevision = payload.revision;
        }
        payload.revision = Number(nextRevision == null ? 0 : nextRevision);
        payload.status = snapshot.status || payload.status || 'draft';
        payload.values = snapshot.draft_values || snapshot.values || payload.values || {};
        payload.has_unpublished_changes = Boolean(snapshot.has_unpublished_changes);
        payload.can_restore = Boolean(snapshot.can_restore);
        rootElement.dataset.revision = String(payload.revision);

        var status = rootElement.querySelector('[data-public-content-status]');
        if (status) {
            status.textContent = payload.has_unpublished_changes
                ? '미공개 변경 있음'
                : (payload.status === 'published' ? '공개 중' : '기본 문구 사용 중');
        }

        var publishButton = rootElement.querySelector('[data-public-content-publish]');
        var restoreButton = rootElement.querySelector('[data-public-content-restore]');
        var archiveButton = rootElement.querySelector('[data-public-content-archive]');
        if (publishButton) publishButton.disabled = !payload.has_unpublished_changes;
        if (restoreButton) restoreButton.disabled = !payload.can_restore;
        if (archiveButton) archiveButton.disabled = payload.status === 'default' || payload.status === 'archived';
    }

    function updateVisibleField(key, value) {
        documentRef.querySelectorAll('[data-public-content-field="' + key + '"]').forEach(function (element) {
            element.textContent = value;
        });
    }

    function modal() {
        return documentRef.getElementById('publicContentEditorModal');
    }

    function closeModal() {
        var element = modal();
        if (!element) return;
        element.hidden = true;
        selectedFieldKey = '';
    }

    function faqModal() {
        return documentRef.getElementById('publicFaqEditorModal');
    }

    function faqContext(key) {
        return payload.faq && payload.faq.contexts ? payload.faq.contexts[key] : null;
    }

    function faqItem(contextKey, itemId) {
        var context = faqContext(contextKey);
        return context && Array.isArray(context.items)
            ? context.items.find(function (item) { return String(item.id) === String(itemId); }) || null
            : null;
    }

    function closeFaqModal() {
        var element = faqModal();
        if (!element) return;
        element.hidden = true;
        selectedFaqContextKey = '';
        selectedFaqItemId = '';
    }

    function openFaq(contextKey, itemId) {
        var context = faqContext(contextKey);
        var item = faqItem(contextKey, itemId);
        var element = faqModal();
        if (!context || !item || !element || busy) return;

        selectedFaqContextKey = contextKey;
        selectedFaqItemId = itemId;
        element.hidden = false;
        element.querySelector('[data-public-faq-context-label]').textContent = context.label || '전 지점 공통 FAQ';
        element.querySelector('[data-public-faq-question-input]').value = String(item.question || '');
        element.querySelector('[data-public-faq-answer-input]').value = String(item.answer || '');
        element.querySelector('[data-public-faq-error]').textContent = '';
        element.querySelector('[data-public-faq-question-input]').focus();
    }

    function openField(key) {
        var definition = field(key);
        var element = modal();
        if (!definition || !element || busy) return;

        selectedFieldKey = key;
        element.hidden = false;
        element.querySelector('[data-public-content-modal-title]').textContent = definition.label;
        element.querySelector('[data-public-content-location]').textContent = definition.location || '';

        var input = element.querySelector('[data-public-content-input]');
        input.value = currentValue(key);
        input.maxLength = Number(definition.max || 3000);
        input.dataset.type = definition.type || 'text';
        input.rows = definition.type === 'textarea' ? 6 : 2;
        input.focus();
        input.setSelectionRange(input.value.length, input.value.length);
    }

    function csrfToken() {
        var meta = documentRef.querySelector('meta[name="csrf-token"]');
        return meta ? meta.getAttribute('content') : '';
    }

    function request(url, method, body) {
        if (!fetchRef || !url || busy) return Promise.resolve(null);
        busy = true;
        rootElement.dataset.busy = '1';
        setMessage('저장 중입니다.', 'progress');

        return fetchRef(url, {
            method: method,
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken(),
            },
            body: JSON.stringify(body || {}),
        }).then(function (response) {
            return response.json().catch(function () { return {}; }).then(function (data) {
                if (!response.ok) {
                    var error = new Error(data.message || '요청을 처리하지 못했습니다.');
                    error.status = response.status;
                    error.data = data;
                    throw error;
                }
                return data;
            });
        }).finally(function () {
            busy = false;
            rootElement.dataset.busy = '0';
        });
    }

    function handleError(error) {
        if (error && error.status === 409) {
            setMessage('다른 관리자가 먼저 수정했습니다. 화면을 새로고침해 주세요.', 'error');
            return;
        }
        if (error && error.status === 403) {
            setMessage('이 페이지를 수정할 권한이 없습니다.', 'error');
            return;
        }
        if (error && error.data && error.data.errors) {
            var validationGroups = Object.values(error.data.errors);
            var validationMessage = validationGroups.length && validationGroups[0].length
                ? validationGroups[0][0]
                : '';
            if (validationMessage) {
                setMessage(validationMessage, 'error');
                var faqError = faqModal() && faqModal().querySelector('[data-public-faq-error]');
                if (faqError && !faqModal().hidden) faqError.textContent = validationMessage;
                return;
            }
        }
        setMessage((error && error.message) || '잠시 후 다시 시도해 주세요.', 'error');
    }

    function saveDraft() {
        if (!selectedFieldKey || busy) return;
        var input = modal().querySelector('[data-public-content-input]');
        var value = input.value.trim();
        if (value === currentValue(selectedFieldKey)) {
            closeModal();
            return;
        }

        var values = {};
        values[selectedFieldKey] = value;
        request(rootElement.dataset.draftUrl, 'PUT', {
            revision: payload.revision,
            values: values,
        }).then(function (result) {
            if (!result) return;
            setStatus(result);
            updateVisibleField(selectedFieldKey, currentValue(selectedFieldKey));
            setMessage('초안을 저장했습니다. 공개하기 전에는 방문자 화면이 바뀌지 않습니다.', 'success', true);
            showSavedToast('초안으로 저장했으며 공개하기 전에는 방문자 화면이 바뀌지 않습니다.');
            closeModal();
        }).catch(handleError);
    }

    function updateVisibleFaqItem(contextKey, itemId, question, answer) {
        documentRef.querySelectorAll('[data-public-faq-item]').forEach(function (element) {
            if (element.dataset.publicFaqContext !== contextKey || element.dataset.publicFaqId !== itemId) return;
            var questionTarget = element.querySelector('[data-public-faq-question]');
            var answerTarget = element.querySelector('[data-public-faq-answer]');
            if (questionTarget) questionTarget.textContent = question;
            if (answerTarget) answerTarget.textContent = answer;
        });
    }

    function saveFaq() {
        if (!selectedFaqContextKey || !selectedFaqItemId || busy) return;
        var context = faqContext(selectedFaqContextKey);
        var item = faqItem(selectedFaqContextKey, selectedFaqItemId);
        var element = faqModal();
        if (!context || !item || !element) return;

        var question = element.querySelector('[data-public-faq-question-input]').value.trim();
        var answer = element.querySelector('[data-public-faq-answer-input]').value.trim();
        var errorTarget = element.querySelector('[data-public-faq-error]');
        if (!question || !answer) {
            errorTarget.textContent = '질문과 답변을 모두 입력해 주세요.';
            return;
        }
        if (question === String(item.question || '') && answer === String(item.answer || '')) {
            closeFaqModal();
            return;
        }

        var contextKey = selectedFaqContextKey;
        var itemId = selectedFaqItemId;
        request(payload.faq.update_url, 'PATCH', {
            revision: payload.faq.revision,
            context_key: contextKey,
            id: itemId,
            question: question,
            answer: answer,
        }).then(function (result) {
            if (!result) return;
            payload.faq.revision = result.revision || payload.faq.revision;
            item.question = question;
            item.answer = answer;
            updateVisibleFaqItem(contextKey, itemId, question, answer);
            setMessage('FAQ를 저장했습니다. 공개 화면에 바로 반영됩니다.', 'success', true);
            showSavedToast('공개 FAQ에 바로 반영되었습니다.');
            closeFaqModal();
        }).catch(handleError);
    }

    function lifecycle(action) {
        var url = rootElement.dataset[action + 'Url'];
        request(url, 'POST', { revision: payload.revision }).then(function (result) {
            if (!result) return;
            setStatus(result);
            Object.keys(payload.values || {}).forEach(function (key) {
                updateVisibleField(key, currentValue(key));
            });
            var messages = {
                publish: '공개했습니다.',
                restore: '직전 공개본으로 복원했습니다.',
                archive: '기본 문구로 전환했습니다.',
            };
            setMessage(messages[action] || '처리했습니다.', 'success');
        }).catch(handleError);
    }

    function bindEditableFields() {
        documentRef.querySelectorAll('[data-public-content-field]').forEach(function (element) {
            var key = element.dataset.publicContentField;
            element.tabIndex = 0;
            element.addEventListener('dblclick', function () { openField(key); });
            element.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    openField(key);
                }
            });
        });

        documentRef.querySelectorAll('[data-public-content-edit]').forEach(function (button) {
            button.addEventListener('click', function () { openField(button.dataset.publicContentEdit); });
        });
    }

    function init() {
        if (!documentRef) return false;
        rootElement = documentRef.getElementById('publicContentEditor');
        payload = parsePayload();
        if (!rootElement || !payload) return false;

        bindEditableFields();
        documentRef.querySelectorAll('[data-public-faq-edit]').forEach(function (button) {
            button.addEventListener('click', function () {
                openFaq(button.dataset.contextKey, button.dataset.itemId);
            });
        });
        var faqLocateButton = rootElement.querySelector('[data-public-faq-locate]');
        var firstFaqEditButton = documentRef.querySelector('[data-public-faq-edit]');
        if (faqLocateButton && !firstFaqEditButton) faqLocateButton.hidden = true;
        faqLocateButton?.addEventListener('click', function () {
            firstFaqEditButton?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstFaqEditButton?.focus({ preventScroll: true });
        });
        rootElement.querySelectorAll('[data-public-content-open-field]').forEach(function (button) {
            button.addEventListener('click', function () {
                openField(button.dataset.publicContentOpenField);
            });
        });
        rootElement.querySelector('[data-public-content-publish]')?.addEventListener('click', function () { lifecycle('publish'); });
        rootElement.querySelector('[data-public-content-restore]')?.addEventListener('click', function () { lifecycle('restore'); });
        rootElement.querySelector('[data-public-content-archive]')?.addEventListener('click', function () { lifecycle('archive'); });
        documentRef.querySelector('[data-public-content-save]')?.addEventListener('click', saveDraft);
        documentRef.querySelector('[data-public-faq-save]')?.addEventListener('click', saveFaq);
        documentRef.querySelectorAll('[data-public-content-cancel]').forEach(function (button) {
            button.addEventListener('click', closeModal);
        });
        documentRef.querySelectorAll('[data-public-faq-cancel]').forEach(function (button) {
            button.addEventListener('click', closeFaqModal);
        });
        modal()?.addEventListener('click', function (event) {
            if (event.target === modal()) closeModal();
        });
        faqModal()?.addEventListener('click', function (event) {
            if (event.target === faqModal()) closeFaqModal();
        });
        documentRef.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                closeModal();
                closeFaqModal();
            }
        });
        setStatus(payload);
        return true;
    }

    return {
        init: init,
        openField: openField,
        closeModal: closeModal,
        saveDraft: saveDraft,
        saveFaq: saveFaq,
        lifecycle: lifecycle,
    };
}));
